'use client'
// eslint-disable-next-line no-restricted-imports
import { LicenseInfo } from '@mui/x-license'

LicenseInfo.setLicenseKey(process.env.NEXT_PUBLIC_MUI_LICENSE_KEY)

export default function MuiXLicense() {
  return null
}
